// Best-effort human-readable message extraction for any thrown value.
//
// Supabase's PostgrestError and FunctionsHttpError are plain objects, not
// Error instances, so `String(e)` renders "[object Object]" in toasts. This
// helper digs into the common shapes (`message`, `error_description`, `error`,
// `details`, `hint`, nested `context.body`) and falls back gracefully.

export function errorMessage(e: unknown, fallback = "Something went wrong"): string {
  if (!e) return fallback;
  if (typeof e === "string") return e;
  if (e instanceof Error && e.message) return e.message;

  if (typeof e === "object") {
    const o = e as Record<string, unknown>;
    const candidates = [
      o.message,
      o.error_description,
      o.error,
      o.details,
      o.hint,
      o.msg,
    ];
    for (const c of candidates) {
      if (typeof c === "string" && c.trim()) return c;
    }
    // Supabase PostgrestError shape sometimes nests under `cause`.
    if (o.cause && typeof o.cause === "object") {
      const inner = errorMessage(o.cause, "");
      if (inner) return inner;
    }
    try {
      const j = JSON.stringify(e);
      if (j && j !== "{}") return j.slice(0, 300);
    } catch { /* fall through */ }
  }
  return fallback;
}
